export default [
  {
    path: '/transportation/myp_airlines',
    name: 'MYPAirlines',
    component: () =>
      import(/* webpackChunkName: "transportation" */ './index.vue')
  },
  {
    path: '/transportation/thousand_island',
    name: 'ThousandIsland',
    component: () =>
      import(/* webpackChunkName: "transportation" */ './index.vue')
  },
  {
    path: '/transportation/mighty_travel',
    name: 'MightyTravel',
    component: () =>
      import(/* webpackChunkName: "transportation" */ './MightyAndIngapu.vue')
  },
  {
    path: '/transportation/ingapu_travel',
    name: 'IngapuTravel',
    component: () =>
      import(/* webpackChunkName: "transportation" */ './MightyAndIngapu.vue')
  }
]
